<app-collapsible-box
  [title]="title"
  [expanded]="expanded"
  (expandedChange)="onExpandedChange($event)"
  [classes]="boxClasses"
  data-testid="collapsible-list">
  @if (items.length === 0) {
    @if (emptyText) {
      <p
        class="break-all px-5 pb-3.5 py-2"
        [ngClass]="classes.empty || 'body-small text-on-surface opacity-50'">
        {{ emptyText }}
      </p>
    }
  } @else {
    <ul class="flex flex-col m-0 list-none" [class.pb-3.5]="!striped">
      @for (item of items; track $index) {
        <li [class]="itemClasses($index)">
          <p
            class="break-all whitespace-pre-wrap flex-1 min-w-0 m-0"
            [ngClass]="classes.itemText || 'body-small text-on-surface opacity-50'">
            {{ item }}
          </p>
          @if (removable) {
            <button
              mat-icon-button
              type="button"
              class="!w-8 !h-8 !p-0 inline-flex! items-center justify-center shrink-0 self-start [--mdc-icon-button-state-layer-size:32px] [--mdc-icon-button-icon-size:20px]"
              [ngClass]="classes.remove || 'text-on-surface opacity-50'"
              [attr.aria-label]="'Remove'"
              [attr.data-testid]="'collapsible-list-remove-' + $index"
              (click)="onRemove($index, $event)">
              <mat-icon class="icon-sm" [ngClass]="classes.remove || 'text-on-surface opacity-50'">
                close
              </mat-icon>
            </button>
          }
        </li>
      }
    </ul>
  }
</app-collapsible-box>
